import axioApi, { setHeader } from 'api/root.api';

export const takedownProject = async (projectId, token)=>{
    const urlEnd = `/editor/project/v1/${projectId}/publish/takedown`;
    setHeader('Authorization', `Bearer ${token}`);
    const response = await axioApi.post(urlEnd);
    const result = response.data;
    return result;
};